// @ts-nocheck
import {FC} from 'react'
import {ColumnInstance} from 'react-table'
import {Job} from '../../core/_models'

type Props = {
  column: ColumnInstance<Job>
}

const JobCustomHeaderColumn: FC<Props> = ({column}) => {
  if (column.Header && typeof column.Header === 'string') {
    const headerProps = column.getHeaderProps()
    const {key, ...restHeaderProps} = headerProps as any
    return <th key={key} {...restHeaderProps}>{column.render('Header')}</th>
  }

  return <>{column.render('Header')}</>
}

export {JobCustomHeaderColumn}